import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../reduxService/hooks';
import { conversionLabel } from '../../../../conversion';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { IMaterialsResult } from '../../../api/IApiResponse';
import { SubSectorPosition } from '../../../enum/Sector';
import { isConcrete } from '../../../../enum/Material';
import { selectResults } from '../../../selector/conversion';
import { IMaterialsProps } from './IMaterials';
import './Materials.scss';

const Materials = (props: IMaterialsProps) => {
    const { t } = useTranslation();
    const results = useAppSelector(selectResults);
    const projectInfo = useAppSelector(selectProjectInfo);
    let sortedA: IMaterialsResult[] = [];
    if (!!results.data && !!results.data.materialsResult.length) {
        let newArray = [...results.data?.materialsResult];
        sortedA = newArray.sort((a, b) => {
            if (a.channel === b.channel) {
                if ((a.subSectorPosition === 0 || !!a.subSectorPosition) && (b.subSectorPosition === 0 || !!b.subSectorPosition)) {
                    if (a.subSectorPosition === SubSectorPosition.Left) {
                        return -1;
                    }
                    if (a.subSectorPosition === SubSectorPosition.Center && b.subSectorPosition === SubSectorPosition.Left) {
                        return 1;
                    }
                    if (a.subSectorPosition === SubSectorPosition.Center && b.subSectorPosition === SubSectorPosition.Right) {
                        return -1;
                    }
                    return 0;
                }
            }
            return a.channel - b.channel;
        });
    }
    return (
        <div className='tablet-results-material d-flex align-items-center m-auto h-85 w-80 '>
            <table id='tableMaterials'>
                <thead>
                    <tr>
                        <th style={{ width: '3%' }} rowSpan={2}>
                            {t('material_id')}
                        </th>
                        <th style={{ width: '22%' }} rowSpan={2}>
                            {t('graphical_results_materials')}
                        </th>
                        <th style={{ width: '7%' }} rowSpan={2}>
                            {t('results_material_thickness', { unit_measure: conversionLabel.m_in[projectInfo.data?.unitOfMeasure as number] })}
                        </th>
                        <th style={{ width: '7%' }} rowSpan={2}>
                            {t('material_roughness')}
                        </th>
                        <th style={{ width: '6%' }} rowSpan={2}>
                            {t('results_material_rock', { unit_measure: conversionLabel.m_in[projectInfo.data?.unitOfMeasure as number] })}
                        </th>
                        <th style={{ width: '3%' }} rowSpan={2}>
                            {t('material_cu')}
                        </th>
                        <th style={{ width: '6%' }} rowSpan={2}>
                            {t('results_material_castoro')}
                        </th>
                        <th style={{ width: '5%' }} rowSpan={2}>
                            {t('material_xties')}
                        </th>
                        <th style={{ width: '7%' }} rowSpan={2}>
                            {t('results_material_geotextile')}
                        </th>
                        <th style={{ width: '4%' }} rowSpan={2}>
                            {t('material_time', { unit_measure: 'h' })}
                        </th>
                        <th style={{ width: '14%' }} colSpan={3}>
                            {t('results_material_shear_stress', { unit_measure: conversionLabel.Nm2_lbfft2[projectInfo.data?.unitOfMeasure as number] })}
                        </th>
                        <th style={{ width: '10%' }} rowSpan={2} colSpan={2}>
                            {t('results_material_velocity', { unit_measure: conversionLabel.ms_fts[projectInfo.data?.unitOfMeasure as number] })}
                        </th>
                        <th style={{ width: '6%' }} rowSpan={2}>
                            {t('modal_subsector_subsector_length', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                        </th>
                    </tr>
                    <tr>
                        <th>{t('results_allowed')}</th>
                        <th>{t('results_calculated')}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {!!sortedA &&
                        sortedA.map((material: IMaterialsResult, index: number) => {
                            let channelAndPosition = material.channel.toString();
                            if (material.subSectorPosition !== undefined) {
                                let character;
                                switch (material.subSectorPosition) {
                                    case SubSectorPosition.Left:
                                        character = t('results_position_left');
                                        break;
                                    case SubSectorPosition.Center:
                                        character = t('results_position_center');
                                        break;
                                    case SubSectorPosition.Right:
                                        character = t('results_position_right');
                                        break;
                                }
                                channelAndPosition = `${material.channel}.${character}`;
                            }

                            let red;
                            if (!isConcrete(material.category) && (material.isDangerousShearStress || material.isDangerousVelocityUnderLining)) red = 'error-color';

                            let background = index % 2 == 0 ? 'bg-white' : 'bg-greyNavButton';

                            return (
                                <tr key={`${channelAndPosition}-${material.bedMaterial}`} className={`${background} ${red}`}>
                                    <td>{channelAndPosition}</td>
                                    <td>{material.bedMaterial}</td>
                                    <td>{material.thickness}</td>
                                    <td>{material.roughness}</td>
                                    <td>{material.rockD50}</td>
                                    <td>{material.cu}</td>
                                    <td>{material.castoro ? t('yes') : ''}</td>
                                    <td>{material.xTies ? t('yes') : ''}</td>
                                    <td>{material.geotextile ? t('yes') : ''}</td>
                                    <td>{material.time}</td>
                                    <td>{isConcrete(material.category) ? '—' : material.allowedShearStress.toFixed(2)}</td>
                                    <td>{material.calculatedShearStress.toFixed(2)}</td>
                                    <td>{isConcrete(material.category) ? <i className='fa-solid fa-triangle-exclamation' /> : material.isDangerousShearStress ? <i className='fa-solid fa-x' /> : <i className='fa-solid fa-check' />}</td>
                                    {material.velocityUnderLining === 0 ? (
                                        <>
                                            <td>-</td>
                                            <td>-</td>
                                        </>
                                    ) : (
                                        <>
                                            <td>{material.velocityUnderLining.toFixed(2)}</td>
                                            <td>{material.isDangerousVelocityUnderLining ? <i className='fa-solid fa-x' /> : <i className='fa-solid fa-check' />}</td>
                                        </>
                                    )}
                                    <td>{material.length.toFixed(2)}</td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
};

export default Materials;
